import 'babel-polyfill';
import { polyfill } from 'es6-promise';
polyfill();
import fontawesome from '../../_common/fa';

import 'flatpickr/dist/flatpickr.js';
import 'flatpickr/dist/flatpickr.css';

import Vue from 'vue';

//  Application
import App from './App';
import { createRouter } from './router';
import state from './state';
import filters from '../../_common/filters/index';

/* vue settings */
const debug = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = debug;

/* router */
const router = createRouter();

//  Plugins
//    Plugins - external
import VueLazyload from 'vue-lazyload';
//import VueAgile from 'vue-agile'
//    Plugins - internal
import routerPlugin from '../../_common/plugins/router.plugin';
import statePlugin from '../../_common/plugins/state.plugin';
import httpPlugin from '../../_common/plugins/http.plugin';
import i18nPlugin from '../../_common/plugins/i18n.plugin';
import validationPlugin from '../../_common/plugins/validation.plugin';
import notificationPlugin from '../../_common/plugins/notification.plugin';

// Register plugins
/* external */
Vue.use(VueLazyload, {
    attempt: 1,
    filter: {
        webp(listener, options) {
            listener.src += options.supportWebp ? '.webp' : '.jpg';
        }
    }
});
/* carousel */
//Vue.use(VueAgile);
/* router */
Vue.use(routerPlugin, { router });
/* state */
Vue.use(statePlugin, { state });
/* http */
Vue.use(httpPlugin, { state, router });
/* localization */
import en from './i18n/en.json';
import ru from './i18n/ru.json';
import es from './i18n/es.json';
import fr from './i18n/fr.json';
import he from './i18n/he.json';
import ar from './i18n/ar.json';
import uz from './i18n/uz.json';
Vue.use(i18nPlugin, {
    state,
    languages: [
        { name: 'en', file: en },
        { name: 'ru', file: ru },
        { name: 'es', file: es },
        { name: 'fr', file: fr },
        { name: 'he', file: he },
        { name: 'ar', file: ar },
        { name: 'uz', file: uz }],
    fallbackLanguage: 'en'
});
/* validation */
Vue.use(validationPlugin, Vue.i18n);
/* notification */
Vue.use(notificationPlugin, { router, messagesRoute: { name: 'profile', hash: '#messages' } });

/* fix anchor link */
const fixIdScrolling = {
    watch: {
        $route(to, from) {
            const currentRoute = this.$router.currentRoute;
            const idToScrollTo = currentRoute.hash;
            this.$nextTick(() => {
                if (idToScrollTo && document.querySelector(idToScrollTo)) {
                    document.querySelector(idToScrollTo).scrollIntoView();
                }
            });
        }
    }
};

/* handle unauthorized */
Vue.http.interceptors.response.use(
    response => response,
    async error => {
        if (error.response.status === 401) {
            await Vue.state.player.logout();
            await Vue.router.teleport.onUnauthorized();
        }
        return Promise.reject(error);
    }
);

/* start application */
let app = new Vue({
    mixins: [fixIdScrolling],
    el: '#app',
    store: state.store,
    router,
    render: h => h(App)
});

window.app = app;



// WEBPACK FOOTER //
// ./skins/bulmasite/main.js